import * as BABYLON from "babylonjs";
import { CoordUtils } from "../core/coordUtils";
import { GeoPoint } from "../core/geoPoint";
import { TextureLoader } from "../core/textureLoader";

export class EarthMeshPart extends BABYLON.Mesh {
    materialColor: BABYLON.Vector3 = new BABYLON.Vector3(1.0, 1.0, 1.0);
    constructor(name: string, scene: BABYLON.Scene, startLat: number, endLat: number, startLon: number, endLon: number, textureName: string) {
        super(name, scene);

        let vertexData = this.generateVertexData(startLat, endLat, startLon, endLon);
        vertexData.applyToMesh(this);

        let material = new BABYLON.ShaderMaterial(`${name}Mat`, scene, "./assets/earth/shaders/earth",
        {
            attributes: ["position", "normal", "uv"],
            uniforms: ["world", "worldViewProjection", "cameraPosition", "lightPosition", "materialColor"]
        });

        let texture = TextureLoader.Load(`assets/app/textures/${textureName}.jpg`, scene);
        texture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
        texture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
        material.setTexture("textureSampler", texture);
        this.material = material;

        this.onBeforeDraw = () => {
            let camPos = scene.activeCamera.position;
            (this.material as BABYLON.ShaderMaterial).setVector3("cameraPosition", camPos);

            // compute light from cam space
            let lightPos = new BABYLON.Vector3(-5, 10, -1);
            lightPos = BABYLON.Vector3.TransformNormal(lightPos, scene.activeCamera.getTranformationMatrix().clone().invert());
            lightPos = lightPos.normalize();
            lightPos.scaleInPlace(1000.0);

            (this.material as BABYLON.ShaderMaterial).setVector3("lightPosition", lightPos);
            (this.material as BABYLON.ShaderMaterial).setVector3("materialColor", this.materialColor);
        };
    }

    private generateVertexData(startLat: number, endLat: number, startLon: number, endLon: number): BABYLON.VertexData {
        const latRes = 16;
        const lonRes = 32;
        let latStep = (endLat - startLat) / latRes;
        let lonStep = (endLon - startLon) / lonRes;

        let vertices: number[] = [];
        let normals: number[] = [];
        let uvs: number[] = [];

        for (let i = 0; i <= latRes; i++) {
            let lat = startLat + i * latStep;
            for (let j = 0; j <= lonRes; j++) {
                let lon = startLon + j * lonStep;
                let point = CoordUtils.geoToBabylon(new GeoPoint(lat, lon, 0.0));
                let normal = BABYLON.Vector3.Normalize(point);
                let uv = new BABYLON.Vector2(j / lonRes, i / latRes);
                vertices.push(point.x, point.y, point.z);
                normals.push(normal.x, normal.y, normal.z);
                uvs.push(uv.x, uv.y);
            }
        }

        let indices: number[] = [];
        let k = 0;
        for (let i = 0; i < latRes; i++) {
            for (let j = 0; j < lonRes; j++) {
                indices.push(k, k + lonRes + 1, k + 1);
                indices.push(k + 1, k + lonRes + 1, k + lonRes + 2);
                k++;
            }
            k++;
        }

        let vertexData = new BABYLON.VertexData();
        vertexData.positions = vertices;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        vertexData.indices = indices;
        return vertexData;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/earthMeshPart.ts